export default {
  default: () => import("/opt/build/repo/layouts/default.vue"),
  page: () => import("/opt/build/repo/layouts/page.vue")
}